import { ChevronLeft, ChevronRight } from '@patrianna-icons/material-icons'

import classes from './styles.module.scss'

type Props = {
  toggleMenu: () => void
  menuHidden: boolean
}

export default function MenuTrigger(props: Props) {
  return (
    <div onClick={props.toggleMenu} className={classes.menuTrigger}>
      {props.menuHidden ? <ChevronRight /> : <ChevronLeft />}
    </div>
  )
}
